// Helper function to convert number to words (English)
export function numberToWords(num) {
  if (num === 0) return "zero";

  const a = [
    "", "one", "two", "three", "four", "five", "six", "seven",
    "eight", "nine", "ten", "eleven", "twelve", "thirteen",
    "fourteen", "fifteen", "sixteen", "seventeen", "eighteen",
    "nineteen"
  ];
  const b = [
    "", "", "twenty", "thirty", "forty", "fifty",
    "sixty", "seventy", "eighty", "ninety"
  ];

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + a[n % 10] : "");
    if (n < 1000)
      return a[Math.floor(n / 100)] + " hundred" + (n % 100 !== 0 ? " " + inWords(n % 100) : "");
    if (n < 1000000)
      return inWords(Math.floor(n / 1000)) + " thousand" + (n % 1000 !== 0 ? " " + inWords(n % 1000) : "");
    return ""; // can be extended for millions and more
  }

  return inWords(num);
}
